import Script from 'next/script'
import Head from '@/components/Head'
import DefaultContentLayout from '@/layouts/defaultContent'
import { getServerSideUserProps } from '@/utils/auth'
import { composeSSR } from '@/utils/ssr'
import { useRouter } from 'next/router'
import useTranslation from '@/hooks/translation'
import Trans from '@/components/i18n/Trans'
// import Faq from '@/components/DynamicFaq'
// import { fetchBretzelRes } from '@/services/api/bretzel'

/**
 * Place types :
 * A - airport
 * C - country
 * R - region
 */
function parsePlace(place) {
  let type, code
  const parsed = place?.split(':')
  if (parsed?.length === 2) {
    type = parsed[0]
    code = parsed[1] ?? 'A'
  } else if (parsed?.length === 1) {
    code = parsed[0]
    type = code.length === 3 ? 'A' : code?.indexOf('-') > -1 ? 'R' : 'C'
  }

  if (!code || !code.length) {
    return undefined
  }

  return type === 'A'
    ? {
        airportCode: code,
      }
    : type === 'C'
    ? {
        countryCode: code,
      }
    : {
        regionCode: code,
      }
}

function Visas() {
  const { t } = useTranslation()
  const { query } = useRouter()

  return (
    <>
      <main className="min-h-screen">
        <Head title={t('pages.visas.seoTitle')} />

        <Script
          src="https://sdk.joinsherpa.io/widget.js?appId=spIxNzAzMj"
          onLoad={() => {
            window.onSherpaEvent = (event) => {
              let segments = []
              // Query example: ?segments=OUTBOUND,CDG,MAD,2022-10-28T19:00:13.001,2022-10-28T22:00:00.001,false_RETURN,MAD,CDG,2022-10-30T19:00:13.001,2022-10-30T22:00:00.001,false
              if (query.segments) {
                try {
                  segments = query.segments.split('_').map((segment) => {
                    let [
                      type,
                      orgin,
                      destination,
                      departure_date,
                      departure_time,
                      arrival_date,
                      arrival_time,
                      isConnection,
                    ] = segment.split(',')

                    let parsedSegment = {
                      segmentType: type,
                      origin: {
                        airportCode: orgin,
                      },
                      destination: {
                        airportCode: destination,
                      },
                      departureDate: departure_date,
                      departureTime: departure_time,
                      arrivalDate: arrival_date,
                      arrivalTime: arrival_time,
                    }
                    if (isConnection === 'true') {
                      parsedSegment['segmentSubType'] = 'TRANSIT'
                    }
                    return parsedSegment
                  })
                } catch (err) {
                  console.error(err)
                }
              } else if (query.od) {
                // OD as origin and destination, no date specified
                const [origin, destination] = query.od.split(',')
                const originPlace = parsePlace(origin)
                const destinationPlace = parsePlace(destination)

                if (originPlace && destinationPlace) {
                  segments.push({
                    segmentType: 'OUTBOUND',
                    origin: originPlace,
                    destination: destinationPlace,
                  })
                }
              }

              const elementConfig = {
                placement: 'discovery',
                segments: segments,
              }

              if (event.type === 'sdkLoaded') {
                // sdk is ready, create and mount new elements
                window.$sherpa.V2.createElement('trip', elementConfig).mount(
                  '#sherpa-trip-element'
                )
              }
            }
          }}
        />

        <header className="bg-primary-10">
          <div className="bg-white pt-85"> </div>
          <div className="container pt-60 lg:px-100 pb-60">
            <div className="row">
              <div className="md:col-8 xl:col-6 text-dark">
                <h1 className="text-50 leading-54 mb-30">
                  <Trans
                    i18nKey="pages.visas.title"
                    components={{
                      strong: <strong className="font-bold" />,
                    }}
                  />
                </h1>
              </div>
            </div>

            <div className="row">
              <div className="mt-20 col-12 text-dark">
                <div
                  id="sherpa-trip-element"
                  className="pt-25 px-25 pb-30 bg-white border border-dark-10 rounded-lg mb-30 drop-shadow-2xl"
                ></div>
              </div>
            </div>

            {/* <section className="pt-30">
              <h3 className="title-3 md:w-8/12">
                {t('pages.referral.faqTitle')}
              </h3>
              <Faq faq={loggedOutFaq} className="bg-white mt-30" />
            </section> */}
          </div>
        </header>
      </main>
    </>
  )
}

Visas.layout = DefaultContentLayout
export default Visas

export const getServerSideProps = composeSSR(
  getServerSideUserProps
  // TODO : add visas FAQ
  // async ({ locale }) => {
  //   try {
  //     const { faqs } = await fetchBretzelRes('referral', { locale })
  //     return {
  //       props: {
  //         loggedOutFaq: faqs.find((f) => f.slug === 'referral-loggedout'),
  //       },
  //     }
  //   } catch (err) {
  //     console.error(err)
  //     return {
  //       props: {},
  //     }
  //   }
  // }
)
